module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('blockquote', [_c('p', [_vm._v(_vm._s(_vm.content))]), (!!_vm.author) ? _c('small', [_vm._v(_vm._s(_vm.author))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4819388","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdBlockquote/index.vue
// module id = yiYA
// module chunks = 13 14